import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {BreadcrumbArrowIcon} from './BreadcrumbArrowIcon';
import {BreadcrumbLink} from './BreadcrumbLink';
import {typographyStyles} from './typographyStyles';

const ListItem = styled.li`
  display: inline;
  ${typographyStyles};
`;

interface BreadcrumbItemProps {
  link: {
    path: string;
    label: string;
  };
  index: number;
}

export const BreadcrumbItem: FC<BreadcrumbItemProps> = ({link, index}) => {
  return (
    <ListItem data-testid="Breadcrumb">
      <BreadcrumbArrowIcon position={index} />
      <BreadcrumbLink link={link} />
    </ListItem>
  );
};
